<template>
  <div>
    <CCard>
<!--      <CCardHeader>-->
<!--        <strong>Dashboard</strong>-->
<!--      </CCardHeader>-->
      <CCardBody>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label class="form__label" style="vertical-align: text-bottom">{{$lang.report.filter.date}}</label> &nbsp;
              <template>
                <date-range-picker style="float: left;width: 100%;" v-model="dateRange" :showWeekNumbers="showWeekNumbers" :showDropdowns="showDropdowns" :autoApply="autoApply"></date-range-picker>
              </template>
            </div>
          </CCol>
<!--          <CCol lg="2">-->
<!--            <div class="form-group">-->
<!--              <label class="form__label">{{-->
<!--                $lang.filter.candidates.filter.industry-->
<!--                }}</label>-->
<!--              <v-select :options="industryOptions" v-model="filter.industry"-->
<!--                @option:selected="getSubIndustry"></v-select>-->
<!--            </div>-->
<!--          </CCol>-->
<!--          <CCol lg="2">-->
<!--            <div class="form-group">-->
<!--              <label class="form__label">{{-->
<!--                $lang.opportunity.filter.subIndustry-->
<!--                }}</label>-->
<!--              <v-select :options="services" multiple="multiple" v-model="filter.services"></v-select>-->
<!--            </div>-->
<!--          </CCol>-->
<!--          <CCol sm="2">-->
<!--            <div class="form-group">-->
<!--              <label class="form__label">{{-->
<!--                $lang.report.filter.countries-->
<!--                }}</label>-->
<!--              <v-select :options="CountryOptions" v-model="filter.country" :clearable="true" ref="refCountry"-->
<!--                @option:selected="loadCities">-->
<!--              </v-select>-->
<!--            </div>-->
<!--          </CCol>-->
<!--          <CCol sm="2">-->
<!--            <div class="form-group">-->
<!--              <label class="form__label">{{-->
<!--                $lang.filter.candidates.filter.cities-->
<!--                }}</label>-->
<!--              <v-select :options="cityOptions" v-model="filter.city">-->
<!--              </v-select>-->
<!--            </div>-->
<!--          </CCol>-->
          <CCol sm="2">
            <div class="form-group" style="margin-top: 30px">
              <CButton type="submit" size="sm" color="primary" @click="applyFilter()"
                v-c-tooltip="$lang.common.filter.button.filter">
                {{ $lang.common.filter.button.filter }}
              </CButton>
              &nbsp;
<!--              <CButton color="danger" size="sm" @click="resetFilter()" v-c-tooltip="$lang.common.filter.button.cancel">-->
<!--                {{ $lang.common.filter.button.cancel }}-->
<!--              </CButton>-->
            </div>
          </CCol>
        </CRow>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <CTabs add-tab-classes="mt-1">
          <span @click="selected = 'Registrations'">
            <CTab>
              <template slot="title">
                Registrations
              </template>
            </CTab>
          </span>
          <span @click="selected = 'Opportunities'">
            <CTab>
              <template slot="title">
                Opportunities / Resources
              </template>
            </CTab>
          </span>
          <span @click="selected = 'Jobs'">
            <CTab>
              <template slot="title">
                Jobs
              </template>
            </CTab>
          </span>
        </CTabs>
        <component v-if="selected == 'Registrations'"
            :is="selected"
            @changeSelected="getTab($event)"
            style="margin-top: 20px"
        >
            <CCardHeader>
              <div class="row">
                <CCol sm="6" class="align-self-center">
                  <strong>Businesses </strong>
                </CCol>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/profile" text="New" type="single" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Bussiness" :count="dashboardResponse.business.new" color="primary"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/profile" type="double" text="Pending" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Bussiness" :count="dashboardResponse.business.pending" color="warning"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/profile" type="double" text="Verified" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Bussiness" :count="dashboardResponse.business.verified" color="success"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/profile" type="double" text="Rejected" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Bussiness" :count="dashboardResponse.business.rejected" color="danger"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/profile" type="single" text="Total" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Bussiness" :count="dashboardResponse.business.total" color="dark"></DashboardBlocks>
                </div>
              </CRow>
            </CCardBody>
            <CCardHeader>
              <div class="row">
                <CCol sm="6" class="align-self-center">
                  <strong>Educational Institutes </strong>
                </CCol>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/education" text="New" type="single" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Education" :count="dashboardResponse.educationalInstitute.new" color="primary">
                  </DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/education" type="double" text="Pending" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Education" :count="dashboardResponse.educationalInstitute.pending" :countNew="dashboardResponse.educationalInstitute.pendingTotal" color="warning"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/education" type="double" text="Verified" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Education" :count="dashboardResponse.educationalInstitute.verified" :countNew="dashboardResponse.educationalInstitute.verifiedTotal" color="success"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/education" type="double" text="Rejected" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Education" :count="dashboardResponse.educationalInstitute.rejected" :countNew="dashboardResponse.educationalInstitute.rejectedTotal" color="danger"></DashboardBlocks>
                </div>
                <div class="col-xxl-2 col-lg-4 col-6">
                  <DashboardBlocks link="/education" type="single" text="Total" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Education" :count="dashboardResponse.educationalInstitute.total" color="dark"></DashboardBlocks>
                </div>
              </CRow>
            </CCardBody>
            <CCardHeader>
              <div class="row">
                <CCol sm="6" class="align-self-center">
                  <strong>HR Agencies</strong>
                </CCol>
              </div>
            </CCardHeader>
            <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/hr" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="HR" status="Pending" text="New" type="single" :count="dashboardResponse.hrAgencies.new" color="primary">
                </DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/hr" type="double" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="HR"  text="Pending" :count="dashboardResponse.hrAgencies.pending" :countNew="dashboardResponse.hrAgencies.pendingTotal" color="warning"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/hr" type="double" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="HR" text="Verified" :count="dashboardResponse.hrAgencies.verified" :countNew="dashboardResponse.hrAgencies.verifiedTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/hr" type="double" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="HR" text="Rejected" :count="dashboardResponse.hrAgencies.rejected" :countNew="dashboardResponse.hrAgencies.rejectedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/hr" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="HR" type="single" text="Total" :count="dashboardResponse.hrAgencies.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
              </CCardBody>
              <CCardHeader>
                <CRow>
                  <CCol sm="6" class="align-self-center">
                    <strong>HR Professionals</strong>
                  </CCol>
                  <CCol sm="6" class="align-self-center">
                    <strong>Students</strong>
                  </CCol>
                </CRow>
              </CCardHeader>
            <CCardBody>
            <CRow>
              <CCol sm="6" class="align-self-center">
                <CRow>
                  <div class="col-xxl-4 col-lg-4 col-4">
                    <DashboardBlocks link="/professional" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Professional" text="New" type="single" :count="dashboardResponse.professionals.new" color="primary"></DashboardBlocks>
                  </div>
                  <div class="col-xxl-4 col-lg-4 col-4">
                    <DashboardBlocks link="/professional" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Professional" type="single" text="Total" :count="dashboardResponse.professionals.total" color="dark"></DashboardBlocks>
                  </div>
                </CRow>
              </CCol>
              <CCol sm="6" class="align-self-center">
                <CRow>
                  <div class="col-xxl-4 col-lg-4 col-4">
                    <DashboardBlocks link="/direct-candidates" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Student" text="New" type="single" :count="dashboardResponse.students.new" color="primary"></DashboardBlocks>
                  </div>
                  <div class="col-xxl-4 col-lg-4 col-4">
                    <DashboardBlocks link="/direct-candidates" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Student" type="single" text="Total" :count="dashboardResponse.students.total" color="dark"></DashboardBlocks>
                  </div>
                </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </component>
        <component v-if="selected == 'Opportunities'"
                   :is="selected"
                   @changeSelected="getTab($event)"
                   style="margin-top: 20px"
        >
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Opportunities </strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/opportunities" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Opportunity" text="New" type="single" :count="dashboardResponse.opportunites.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/opportunities" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Opportunity" type="double" text="Open" :count="dashboardResponse.opportunites.open" :countNew="dashboardResponse.opportunites.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/opportunities" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Opportunity" type="double" text="Closed" :count="dashboardResponse.opportunites.closed" :countNew="dashboardResponse.opportunites.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/opportunities" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Opportunity" type="double" text="Draft" :count="dashboardResponse.opportunites.draft" :countNew="dashboardResponse.opportunites.draftTotal" color="warning"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/opportunities" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Opportunity" type="single" text="Total" :count="dashboardResponse.opportunites.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Resources</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/resource" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Resource" text="New" type="single" :count="dashboardResponse.resources.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/resource" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Resource" type="double" text="Available" :count="dashboardResponse.resources.available" :countNew="dashboardResponse.resources.availableTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/resource" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Resource" type="double" text="Occupied" :count="dashboardResponse.resources.occupied" :countNew="dashboardResponse.resources.occupiedTotal" color="warning"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/resource" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Resource" type="single" text="Total" :count="dashboardResponse.resources.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
        </component>
        <component v-show="selected == 'Jobs'"
                   :is="selected"
                   @changeSelected="getTab($event)"
                   style="margin-top: 20px"
        >
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Jobs</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/job-openings" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Job" text="New" type="single" :count="dashboardResponse.jobs.total" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/job-openings" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Job" type="double" text="Open" :count="dashboardResponse.jobs.open" :countNew="dashboardResponse.jobs.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/job-openings" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Job" type="double" text="Closed" :count="dashboardResponse.jobs.closed" :countNew="dashboardResponse.jobs.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks link="/job-openings" :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Job" type="single" text="Total" :count="dashboardResponse.jobs.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>B2B Jobs</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="B2BJob" link="/job-openings" text="New" type="single" :count="dashboardResponse.b2bJobs.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="B2BJob" link="/job-openings" type="double" text="Open" :count="dashboardResponse.b2bJobs.open" :countNew="dashboardResponse.b2bJobs.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="B2BJob" link="/job-openings" type="double" text="Closed" :count="dashboardResponse.b2bJobs.closed" :countNew="dashboardResponse.b2bJobs.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="B2BJob" link="/job-openings" type="single" text="Total" :count="dashboardResponse.b2bJobs.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Direct Jobs</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="DirectJob" link="/job-openings" text="New" type="single" :count="dashboardResponse.directJobs.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="DirectJob" link="/job-openings" type="double" text="Open" :count="dashboardResponse.directJobs.open" :countNew="dashboardResponse.directJobs.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="DirectJob" link="/job-openings" type="double" text="Closed" :count="dashboardResponse.directJobs.closed" :countNew="dashboardResponse.directJobs.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="DirectJob" link="/job-openings" type="single" text="Total" :count="dashboardResponse.directJobs.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Placements</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Placement" link="/job-openings" text="New" type="single" :count="dashboardResponse.placements.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Placement" link="/job-openings" type="double" text="Open" :count="dashboardResponse.placements.open" :countNew="dashboardResponse.placements.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Placement" link="/job-openings" type="double" text="Closed" :count="dashboardResponse.placements.closed" :countNew="dashboardResponse.placements.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Placement" link="/job-openings" type="single" text="Total" :count="dashboardResponse.placements.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Internships</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Internship" link="/job-openings" text="New" type="single" :count="dashboardResponse.internships.new" color="primary"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Internship" link="/job-openings" type="double" text="Open" :count="dashboardResponse.internships.open" :countNew="dashboardResponse.internships.openTotal" color="success"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Internship" link="/job-openings" type="double" text="Closed" :count="dashboardResponse.internships.closed" :countNew="dashboardResponse.internships.closedTotal" color="danger"></DashboardBlocks>
              </div>
              <div class="col-xxl-2 col-lg-4 col-6">
                <DashboardBlocks :startDate="dateRange.startDate" :endDate="dateRange.endDate" module="Internship" link="/job-openings" type="single" text="Total" :count="dashboardResponse.internships.total" color="dark"></DashboardBlocks>
              </div>
            </CRow>
          </CCardBody>
        </component>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";
import store from "../store/store";
import {
  dashboardProfileList,
  dashboardNumberOfEntitiesList,
  industry,
  country
} from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import UserReport from "./dashboardComponents/UserReport";
import PendingProfileUpdateRequest from "./profile/PendingProfileUpdateRequest";
import RecentOpportunities from "./dashboardComponents/RecentOpportunities";
import RecentResources from "./dashboardComponents/RecentResources";
import RecentInquiry from "./dashboardComponents/RecentInquiry";
import RecentGroupPost from "./dashboardComponents/RecentGroupPost";
import RecentOpportunityReport from "./dashboardComponents/RecentOpportunityReport";
import RecentResourceReport from "./dashboardComponents/RecentResourceReport";
import OpportunityChart from "./dashboardComponents/OpportunityChart";
import ResourceChart from "./dashboardComponents/ResourceChart";
import RecentGroup from "./dashboardComponents/RecentGroup";
import RecentOpportunityResponse from "./dashboardComponents/RecentOpportunityResponse";
import RecentResourceResponse from "./dashboardComponents/RecentResourceResponse";
import RecentTransaction from "./dashboardComponents/RecentTransaction";
import RecentPendingProfile from "./dashboardComponents/RecentPendingProfile";
import DashboardBlocks from "/src/components/DashboardBlocks";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

Vue.use(ServerTable, {}, false);
Vue.use(VueTelInput);
export default {
  name: "DashboardItem",
  mixins: [Mixin],
  components: {
    RecentPendingProfile,
    RecentTransaction,
    RecentResourceResponse,
    RecentOpportunityResponse,
    // RecentPostResponse,
    RecentGroup,
    PendingProfileUpdateRequest,
    // RecentPosts,
    RecentOpportunities,
    RecentResources,
    RecentInquiry,
    // RecentPostReport,
    RecentOpportunityReport,
    RecentGroupPost,
    RecentResourceReport,
    ResourceChart,
    // PostChart,
    OpportunityChart,
    UserReport,
    DashboardBlocks,
    DateRangePicker
  },
  data() {
    return {
      dashboardResponse: {},
      currencyOptions: [],
      cityOptions: [],
      industryOptions: [],
      showWeekNumbers: true,
      showDropdowns: true,
      autoApply: true,
      timePicker: false,
      timePicker24Hour: false,
      dateRange:{
        startDate:"",
        endDate:"",
      },
      tabPaneActiveKey: 1,
      alertMessage: "",
      userType: localStorage.getItem("roleName"),
      role: localStorage.getItem("roleName"),
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      dismissCountDownS: 0,
      self: this,
      count: 0,
      moduleDashboardProfileList: dashboardProfileList,
      moduleDashboardNumberOfEntitiesList: dashboardNumberOfEntitiesList,
      locationText: "",
      showProfile: false,
      phone: "",
      dismissCountDown: 0,
      submitStatus: null,
      selected: "Registrations",
      selectedtab: "",
      entitiesNumber: [],
      VerifierData: [],
      tableItems: [],
      listUrl: "/dashboard/profile/requests/list/",
      tableFields: [
        { key: "avatar", label: "", _classes: "text-center" },
        { key: "user" },
        { key: "industry" },
        { key: "country", _classes: "text-center" },
        { key: "registered" },
      ],
      columns: ["name", "status", "addedRequest", "actions"], //'title','company'
      data: [],
      options: {
        headings: {
          name: this.$lang.profileRequest.table.name,
          status: this.$lang.profileRequest.table.status,
          addedRequest: this.$lang.profileRequest.table.addedRequest,
        },
        editableColumns: ["name", "isVerified"],
        sortable: ["name", "isVerified"],
        filterable: ["name", "isVerified"],
      },
      filter: {
        industry: "",
        services: "",
        country: "",
        city: "",
      },
      services: [],
      CountryOptions: [],
      moduleIndustry: industry,
      countryModule: country,
    };
  },
  mounted() {
    let self = this;
    let today = new Date();
    let formattedToday = today.toISOString().split('T')[0];
    let fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(today.getDate() - 15);
    let formattedFifteenDaysAgo = fifteenDaysAgo.toISOString().split('T')[0];
    self.dateRange.startDate = formattedToday;
    self.dateRange.endDate = formattedFifteenDaysAgo;
    store.commit("showLoader", false); // Loader Off
    this.loadIndustry();
    this.countryList();
    // setTimeout(() => {
    this.loadStatistics();
    // }, 2000);
    // eslint-disable-next-line no-undef
    axios
      .get(this.listUrlApi(this.moduleDashboardProfileList))
      .then((response) => {
        self.tableItems = response.data.data;
        self.count = response.data.count;
        if (response.data.length > 0) {
          self.showProfile = true;
        }
      });
    // eslint-disable-next-line no-undef
    axios
      .get(this.listUrlApi(this.moduleDashboardNumberOfEntitiesList))
      .then((response) => {
        self.entitiesNumber = response.data.data;
        self.VerifierData = response.data.data.verifierData;
      });
  },
  filters: {
    dateCell(value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date(val) {
      return val ? val.toLocaleString() : ''
    }
  },
  methods: {
    countryList() {
      let self = this;
      axios.get(this.listUrlApi(this.countryModule)).then((response) => {
        response.data.data.map(function (value, key) {
          self.CountryOptions.push({ value: value.id, label: value.name });
          self.currencyOptions.push(
            {
              value: value.id,
              label: value.currencySymbol + ' (' + value.name + '-' + value.countryCode + ' )'
            });
        });
      });
    },
    loadIndustry() {
      let self = this;
      axios.get(this.listUrlApi(this.moduleIndustry)).then((response) => {
        response.data.data.map(function (value, key) {
          if (value.industryId === "") {
            self.industryOptions.push({value: value.id, label: value.industry});
          }
        });
      });
    },
    applyFilter() {
      let self = this;
      let industry = "";
      let country, city, services = "";
      self.selectedServices = [];
      self.selectedSize = [];
      industry = this.checkNullValue(this.filter.industry) ? this.filter.industry.value : '';
      services = this.checkNullValue(this.filter.services) ? this.filter.services.value : '';
      country = this.checkNullValue(this.filter.country) ? this.filter.country.value : '';
      city = this.checkNullValue(this.filter.city) ? this.filter.city.value : '';
       if (this.checkNullValue(this.filter.services)) {
        services = self.filter.services;
        services.map(function (value, key) {
          self.selectedServices.push(value.value);
        });
      }
      const reqObj = {
        dateRange: this.dateRange,
        industry: industry,
        country: country,
        cities: city,
        services: self.selectedServices,
      };
      store.commit("showLoader", true);
      axios.post('/dashboard/user-statistics',reqObj).then((response) => {
        self.dashboardResponse = response.data.data;
        store.commit("showLoader", false);
      });
    },
    getSubIndustry() {
      let self = this;
      if (self.filter.industry.value > 0) {
        const postData = {industry_id: self.filter.industry.value};
        axios
            .post(this.listUrlApi(this.moduleIndustry), postData)
            .then((response) => {
              self.services = [];
              response.data.data.map(function (value, key) {
                if (value.industryId > 0) {
                  self.services.push({
                    value: value.id,
                    label: value.SubIndustry,
                  });
                }
              });
            });
      }
    },
    getTab(tab) {
      let self = this;
      self.selectedtab = tab;
    },
    rowClickHandler(item) {
      this.$router.push({ path: `profile/view/${item.user.id}` });
    },
    loadCities() {
      let self = this;
      self.filter.city = '';
      axios.get('/cities/country-cities/' + self.filter.country.value).then((response) => {
        self.cityOptions = [];
        response.data.data.map(function (value, key) {
          self.cityOptions.push({value: value.id, label: value.name});
        });
      });
    },
    loadStatistics() {
      let self = this;
      const reqObj = {
        dateRange: this.dateRange,
      };
      axios.post('/dashboard/user-statistics',reqObj).then((response) => {
        self.dashboardResponse = response.data.data;
      });
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;}
</style>
